import React from 'react';
import PropTypes from 'prop-types';
import logo from 'assets/img/logo-white.png';

const Banner = ({ title }) => {
  return (
    <div className="w-100 banner tr pa4 flex justify-between items-center">
      <img height="49.9" width="46.9" src={logo} alt="Oi logo" />
      <strong className="banner-title">{title}</strong>
    </div>
  );
};

Banner.propTypes = {
  title: PropTypes.string
};

export default Banner;
